import Carousel from 'react-bootstrap/Carousel';
import React, { useEffect, useState } from "react";
import { StyledCarousel, StyledCaption } from '../../utils/common-styles';

export default function CarouselFader() {

    const [props, setProps] = useState([]);
    const windowWidth = window.innerWidth;

    useEffect(() => {
        
        const getProps = async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/cms/slider`);
            const data = await response.json();

            setProps(data.payload.content);
        }

        if (windowWidth >= 480) {
            getProps();
        }
    }, [windowWidth]);

    return (
        <>
        {windowWidth >= 480 && (
            <StyledCarousel fade className="d-none d-md-block">
            {props.map((item, index) => {
                return (
                    <Carousel.Item key={index} style={{maxHeight: "500px"}}>
                        <img
                            className="d-block w-100"
                            style={{overflow: "hidden"}}
                            src={item.src}
                            alt={item.alt}
                        />
                        <StyledCaption>
                            <h1>{item.label}</h1>
                            <p>{item.text}</p>
                            <p className="subtitle">{item.subtitle}</p>
                        </StyledCaption>
                    </Carousel.Item>
                );
            })}
        </StyledCarousel>
        )}
        </>
    );
}
